import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import desktop from "assets/common/common/desktop.svg";

const menuItems = [
    { label: "항공해운", path: "air" },
    { label: "모닝택배", path: "morning" },
    { label: "모닝퀵", path: "quick" },
    { label: "특송화물", path: "express" },
];

const Header = ({ subdomain }: { subdomain: string }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const location = useLocation();

    const handleTabClick = (index: number, path: string) => {
        setActiveIndex(index);

        const { hostname, port, protocol } = window.location;

        let baseDomain;

        if (hostname.includes("localhost")) {
            baseDomain = port ? `localhost:${port}` : "localhost:3000";
        } else if (hostname.includes("ilshingroup")) {
            baseDomain = `ilshingroup.com`;
        } else {
            baseDomain = hostname;
        }

        const newURL = `${protocol}//${path}.${baseDomain}`;
        window.location.assign(newURL);
    };

    useEffect(() => {
        const subdomain = window.location.hostname.split(".")[0];
        const currentIndex = menuItems.findIndex(item => item.path === subdomain);
        if (currentIndex !== -1) {
            setActiveIndex(currentIndex);
        }
    }, []);

    const visible = subdomain === "morning" || subdomain === "quick" || subdomain === "express" || subdomain === "air";

    if (!visible) return null;

    // if (subdomain === "default" || subdomain === "www" || location.key === "default") return null;

    return (
        <div className="h-10 w-full bg-[#f8f8f8] border-b relative flex items-center justify-center">
            <div className="flex w-full justify-center max-w-[1200px] mx-auto relative">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className={`w-full max-w-[131px] p-2.5 flex items-center justify-center border-l text-[13.5px] cursor-pointer ${
                            activeIndex === index
                                ? "bg-white text-[#173478] relative after:absolute after:bottom-[-1px] after:left-0 after:w-full after:h-[1px] after:bg-white"
                                : "text-[#666]"
                        } ${index === menuItems.length - 1 ? "border-r" : ""}`}
                        onClick={() => handleTabClick(index, item.path)}
                    >
                        {item.label}
                    </div>
                ))}

                <Link
                    to="https://helpu.kr/ilshinair"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-new text-white flex items-center gap-x-2 absolute right-0 top-0 bottom-0 px-5 text-[18px] font-[500] responsive1200:hidden"
                >
                    <img src={desktop} alt="" />
                    원격지원
                </Link>
            </div>
        </div>
    );
};

export default Header;
